module.exports = __webpack_public_path__ + "media/theme/cta-icon-30975d96.png";